/**
 * Prydnadskuddar tygbibliotek — facit: docs/mockup-kuddar/prydnadskuddar.html
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pk-lib]');
  if (!root) return;

  document.body.classList.add('pk-lib-active');

  function readJson(sel) {
    var el = document.querySelector(sel);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var PRODUCTS = readJson('[data-pk-products]') || {};
  var INNER = readJson('[data-pk-inner-json]') || { price: 16500, image: '', v40: null, v50: null, avail40: false, avail50: false };
  var metaUrl = root.getAttribute('data-pk-meta-url');
  if (!metaUrl) return;

  fetch(metaUrl, { credentials: 'same-origin' })
    .then(function (r) {
      return r.json();
    })
    .then(function (META) {
      if (!META || !META.ordning) return;
      boot(META);
    })
    .catch(function () {});

  function boot(META) {

  function $(s, r) {
    return (r || document).querySelector(s);
  }
  function $$(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }

  function kr(cents) {
    var n = Math.round((cents || 0) / 100);
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0kr';
  }

  function sizeLabel(s) {
    return s.replace('x', ' × ');
  }

  /* CDN-nyckel: samma fil trots host/?width=/_1200x/_crop_*. */
  function imageKey(url) {
    if (!url) return '';
    var u = String(url).split('#')[0].split('?')[0];
    u = u.replace(/^https?:/i, '');
    var m = u.match(
      /\/(?:cdn\/shop\/(?:files|products|assets)|s\/files\/\d+\/\d+\/(?:files|products)|(?:t\/\d+\/)?assets)\/(.+)$/i
    );
    var path = m ? m[1] : u.replace(/^\/\//, '').replace(/^[^/]+\//, '');
    path = path.replace(
      /_(?:\d+x\d*|\d+x|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.[a-z0-9]+$)/i,
      ''
    );
    path = path.replace(/_crop_[a-z]+(?=\.[a-z0-9]+$)/i, '');
    return path.toLowerCase();
  }

  /* När-duplikat: samma foto per kuddstorlek (…50x50_2 ≈ …40x60_2), inte SKU-siffror. */
  function imageNearKey(url) {
    var key = imageKey(url);
    if (!key) return '';
    var parts = key.split('/');
    var base = parts[parts.length - 1];
    base = base.replace(/40\s*x\s*60|50\s*x\s*50/gi, '');
    base = base.replace(/_+/g, '_').replace(/^_|_$/g, '');
    parts[parts.length - 1] = base;
    return parts.join('/');
  }

  /* Kort ~17vw desktop (3-col i halva kapitlet), 50vw mobil (2-col). */
  var CARD_SIZES = '(max-width: 760px) 50vw, 17vw';

  function cardImgAttrs(src, srcset) {
    var out = 'src="' + (src || '') + '"';
    if (srcset) {
      out += ' srcset="' + srcset + '" sizes="' + CARD_SIZES + '"';
    }
    return out;
  }

  function productCardSrc(p) {
    return (p && (p.bildCard || p.bild)) || '';
  }

  function productCardSrcset(p) {
    return (p && p.bildSrcset) || '';
  }

  /* Kortbilder: produkt + miljö (max 5, samma tak som vanliga collection-kort). */
  function cardSlideList(f, p) {
    var slides = [];
    var primary = productCardSrc(p);
    if (primary) {
      slides.push({ src: primary, srcset: productCardSrcset(p), primary: true });
    }
    if (f.miljoCard) {
      slides.push({ src: f.miljoCard, srcset: f.miljoCardSrcset || '', primary: false });
    }
    (f.miljo || []).forEach(function (u, i) {
      if (slides.length >= 5 || !u) return;
      /* Första miljö-URL:en är samma foto som miljoCard (bara större). */
      if (i === 0 && f.miljoCard) return;
      slides.push({ src: u, srcset: '', primary: false });
    });
    return slides;
  }

  /* Kort: ingen snabbköp-+ — köp via panelen. */
  function cardMediaHtml(f, p, j) {
    var slides = cardSlideList(f, p);
    var multi = slides.length > 1;
    var slidesHtml = slides
      .map(function (sl, i) {
        var img =
          '<img ' +
          (sl.primary ? 'data-pk-kbild ' : '') +
          cardImgAttrs(sl.src, sl.srcset) +
          ' alt="" loading="lazy">';
        return (
          '<span class="pk-lib__kort-slide" data-slide-index="' + i + '">' + img + '</span>'
        );
      })
      .join('');
    var bar = multi
      ? '<span class="pk-lib__kort-bar" data-pk-card-bar style="--n:' +
        slides.length +
        '"><span class="pk-lib__kort-progress" data-pk-card-progress></span></span>'
      : '';
    return (
      '<span class="pk-lib__kort-m' +
      (multi ? ' is-multi' : '') +
      '" data-pk-card-media><span class="pk-lib__kort-slider" data-pk-card-slider>' +
      slidesHtml +
      '</span>' +
      bar +
      '</span>'
    );
  }

  function initCardSliders(scope) {
    if (window.matchMedia('(min-width: 761px)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    $$( '[data-pk-card-slider]', scope || root).forEach(function (slider) {
      if (slider.dataset.sliderReady) return;
      slider.dataset.sliderReady = '1';
      var media = slider.closest('[data-pk-card-media]');
      if (!media) return;
      var progress = media.querySelector('[data-pk-card-progress]');
      if (!progress) return;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio > 0.6) {
              var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10) || 0;
              progress.style.transform = 'translateX(' + idx * 100 + '%)';
            }
          });
        },
        { root: slider, threshold: [0.6] }
      );
      slider.querySelectorAll('[data-slide-index]').forEach(function (slide) {
        observer.observe(slide);
      });
    });
  }

  /* Bygg färggrupper per tyg från produkter */
  var TYGER = {};
  META.ordning.forEach(function (tk) {
    var meta = META.tyger[tk];
    TYGER[tk] = {
      namn: meta.namn,
      text: meta.text,
      produkttext: meta.produkttext,
      farger: []
    };
    meta.farger.forEach(function (fc) {
      var s50 = PRODUCTS['prydnadskudde-50x50-' + tk + '-' + fc.k];
      var s40 = PRODUCTS['prydnadskudde-40x60-' + tk + '-' + fc.k];
      if (!s50 && !s40) return;
      var base = s50 || s40;
      var namn = fc.namn || base.fargNamn || fc.k;
      var nara = (s50 && s50.nara) || (s40 && s40.nara) || base.bild;
      var miljo = [];
      var miljoSeen = {};
      var miljoNear = {};
      function pushMiljo(list) {
        (list || []).forEach(function (u) {
          if (!u) return;
          var key = imageKey(u);
          var near = imageNearKey(u);
          if (!key || miljoSeen[key] || (near && miljoNear[near])) return;
          miljoSeen[key] = true;
          if (near) miljoNear[near] = true;
          miljo.push(u);
        });
      }
      /* Aktuell storleks miljö först; andra storleken fyller på utan när-dubbletter. */
      pushMiljo(s50 && s50.miljo);
      pushMiljo(s40 && s40.miljo);
      var miljoCard =
        (s50 && s50.miljoCard) || (s40 && s40.miljoCard) || miljo[0] || '';
      var miljoCardSrcset =
        (s50 && s50.miljoCardSrcset) || (s40 && s40.miljoCardSrcset) || '';
      TYGER[tk].farger.push({
        k: fc.k,
        namn: namn,
        nara: nara,
        miljo: miljo,
        miljoCard: miljoCard,
        miljoCardSrcset: miljoCardSrcset,
        storlekar: {
          '50x50': s50 || null,
          '40x60': s40 || null
        }
      });
    });
  });

  var ORDNING = META.ordning.filter(function (tk) {
    return TYGER[tk].farger.length > 0;
  });
  if (!ORDNING.length) return;

  /* ---- Render kapitel ---- */
  var navEl = $('[data-pk-tygnav]', root);
  var kapEl = $('[data-pk-kapitel]', root);

  navEl.innerHTML = ORDNING.map(function (tk, i) {
    return (
      '<a href="#pk-' +
      tk +
      '" data-pk-nav="' +
      tk +
      '">' +
      TYGER[tk].namn +
      '<small>0' +
      (i + 1) +
      '</small></a>'
    );
  }).join('');

  kapEl.innerHTML = ORDNING.map(function (tk, i) {
    var t = TYGER[tk];
    var f0 = t.farger[0];
    var minPris = Infinity;
    t.farger.forEach(function (f) {
      ['50x50', '40x60'].forEach(function (s) {
        if (f.storlekar[s] && f.storlekar[s].price < minPris) minPris = f.storlekar[s].price;
      });
    });
    if (!isFinite(minPris)) minPris = 0;

    var prickar = t.farger
      .map(function (f, j) {
        return (
          '<button type="button" class="pk-lib__prick" data-pk-farg="' +
          j +
          '" title="' +
          f.namn.replace(/"/g, '&quot;') +
          '" aria-pressed="' +
          (j === 0) +
          '" style="background-image:url(' +
          f.nara +
          ')"></button>'
        );
      })
      .join('');

    var kort = t.farger
      .map(function (f, j) {
        var p = f.storlekar['50x50'] || f.storlekar['40x60'];
        var s = f.storlekar['50x50'] ? '50x50' : '40x60';
        return (
          '<a href="' +
          (p.url || '#') +
          '" data-pk-kort="' +
          j +
          '">' +
          cardMediaHtml(f, p, j) +
          '<span class="pk-lib__kort-n">' +
          t.namn +
          ' ' +
          f.namn +
          '<small data-pk-kpris>' +
          kr(p.price) +
          ' · ' +
          sizeLabel(s) +
          ' cm</small></span><span class="pk-lib__valj">Se mer →</span></a>'
        );
      })
      .join('');

    var svep = t.farger
      .map(function (f, j) {
        return (
          '<figure data-pk-svepi="' +
          j +
          '"><img src="' +
          f.nara +
          '" alt="" loading="lazy"><figcaption><b>' +
          t.namn +
          ' ' +
          f.namn +
          '</b><span>' +
          (j + 1) +
          ' / ' +
          t.farger.length +
          '</span></figcaption></figure>'
        );
      })
      .join('');

    return (
      '<section class="pk-lib__kap" id="pk-' +
      tk +
      '" data-pk-tyg="' +
      tk +
      '" data-pk-storlek="50x50">' +
      '<div class="pk-lib__tyg" data-pk-lupp><img alt="" src="' +
      f0.nara +
      '"><span class="pk-lib__tyg-namn"><b data-pk-tygnamn>' +
      t.namn +
      ' ' +
      f0.namn +
      '</b></span></div>' +
      '<div class="pk-lib__svep" data-pk-svep>' +
      svep +
      '</div><div class="pk-lib__svep-linje" style="--n:' +
      t.farger.length +
      '"><i></i></div>' +
      '<div class="pk-lib__info"><div><span class="pk-lib__nr">0' +
      (i + 1) +
      '</span><h2>' +
      t.namn +
      '</h2></div>' +
      '<p class="pk-lib__info-text">' +
      t.text +
      '</p>' +
      '<div class="pk-lib__fakta"><span>Färger<b>' +
      t.farger.length +
      '</b></span><span>Storlek<b class="pk-lib__stval"><button type="button" data-pk-kst="50x50" aria-pressed="true">50 × 50</button><button type="button" data-pk-kst="40x60" aria-pressed="false">40 × 60</button></b></span><span>Pris<b>' +
      kr(minPris) +
      '</b></span></div>' +
      '<div class="pk-lib__farger">' +
      prickar +
      '</div><div class="pk-lib__fargnamn" data-pk-fargnamn>' +
      f0.namn +
      '</div>' +
      '<div class="pk-lib__kort">' +
      kort +
      '</div></div></section>'
    );
  }).join('');

  initCardSliders(root);

  /* ---- Färg / lupp ---- */
  function visaFarg(kap, j, las, utanDimning) {
    var t = TYGER[kap.dataset.pkTyg];
    var f = t.farger[j];
    if (!f) return;
    var img = $('[data-pk-lupp] img', kap);
    if (img) {
      img.style.opacity = 0;
      setTimeout(function () {
        img.src = f.nara;
        img.style.opacity = 1;
      }, 220);
    }
    var tn = $('[data-pk-tygnamn]', kap);
    if (tn) tn.textContent = t.namn + ' ' + f.namn;
    var fn = $('[data-pk-fargnamn]', kap);
    if (fn) fn.textContent = f.namn;
    if (!utanDimning) {
      $$('[data-pk-kort]', kap).forEach(function (a) {
        a.classList.toggle('is-dimmad', +a.dataset.pkKort !== j);
      });
    }
    if (las) {
      kap.dataset.pkLast = String(j);
      $$('[data-pk-farg]', kap).forEach(function (b) {
        b.setAttribute('aria-pressed', +b.dataset.pkFarg === j ? 'true' : 'false');
      });
    }
  }

  $$('.pk-lib__kap', root).forEach(function (kap) {
    kap.dataset.pkLast = '0';
    $$('[data-pk-farg]', kap).forEach(function (b) {
      b.addEventListener('mouseenter', function () {
        visaFarg(kap, +b.dataset.pkFarg);
      });
      b.addEventListener('click', function () {
        visaFarg(kap, +b.dataset.pkFarg, true);
      });
    });
    var farger = $('.pk-lib__farger', kap);
    if (farger) {
      farger.addEventListener('mouseleave', function () {
        visaFarg(kap, +kap.dataset.pkLast);
        $$('[data-pk-kort]', kap).forEach(function (a) {
          a.classList.remove('is-dimmad');
        });
      });
    }
    $$('[data-pk-kort]', kap).forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        visaFarg(kap, +a.dataset.pkKort, false, true);
      });
    });
    var kort = $('.pk-lib__kort', kap);
    if (kort) {
      kort.addEventListener('mouseleave', function () {
        visaFarg(kap, +kap.dataset.pkLast, false, true);
      });
    }
    var lupp = $('[data-pk-lupp]', kap);
    if (lupp) {
      lupp.addEventListener('mousemove', function (e) {
        var r = lupp.getBoundingClientRect();
        var img = lupp.querySelector('img');
        if (!img) return;
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(1.9)';
      });
      lupp.addEventListener('mouseleave', function () {
        var img = lupp.querySelector('img');
        if (!img) return;
        img.style.transform = '';
        img.style.transformOrigin = '';
      });
    }
  });

  /* Tyglisten aktiv */
  var navs = $$('[data-pk-nav]', root);
  function syncNav() {
    var aktiv = ORDNING[0];
    ORDNING.forEach(function (tk) {
      var el = document.getElementById('pk-' + tk);
      if (el && el.getBoundingClientRect().top < 200) aktiv = tk;
    });
    navs.forEach(function (a) {
      a.classList.toggle('is-aktiv', a.dataset.pkNav === aktiv);
    });
  }
  addEventListener('scroll', syncNav, { passive: true });
  if (navs[0]) navs[0].classList.add('is-aktiv');

  /* Storlek i kapitel */
  $$('[data-pk-kst]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      var kap = b.closest('.pk-lib__kap');
      var t = TYGER[kap.dataset.pkTyg];
      var s = b.dataset.pkKst;
      kap.dataset.pkStorlek = s;
      $$('[data-pk-kst]', kap).forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      $$('[data-pk-kort]', kap).forEach(function (a) {
        var f = t.farger[+a.dataset.pkKort];
        var q = f.storlekar[s];
        var img = a.querySelector('[data-pk-kbild]');
        if (!q) {
          a.style.display = 'none';
          return;
        }
        a.style.display = '';
        a.href = q.url || '#';
        if (img) {
          img.style.opacity = 0;
          setTimeout(function () {
            img.src = productCardSrc(q);
            if (productCardSrcset(q)) {
              img.setAttribute('srcset', productCardSrcset(q));
              img.setAttribute('sizes', CARD_SIZES);
            } else {
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
            }
            img.style.opacity = 1;
          }, 200);
        }
        var pris = a.querySelector('[data-pk-kpris]');
        if (pris) pris.textContent = kr(q.price) + ' · ' + sizeLabel(s) + ' cm';
      });
    });
  });

  /* ---- Cart helpers ---- */
  function openCartDrawer() {
    var trigger = document.querySelector('[data-cart-drawer-open]');
    if (trigger) trigger.click();
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function syncCartBadges() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.hidden = false;
            el.removeAttribute('hidden');
          } else {
            el.hidden = true;
            el.setAttribute('hidden', '');
          }
        });
      })
      .catch(function () {});
  }

  /* ---- Panel ---- */
  var panel = $('[data-pk-panel]', root);
  var pv = null;

  function currentProduct(f, s) {
    return f.storlekar[s] || f.storlekar['50x50'] || f.storlekar['40x60'];
  }

  /*
   * Panelgalleri: bara vald storleks media (inte båda storlekarna).
   * URL-dedupe här; pk-nara-* är ofta samma foto som en miljöbild → aHash efteråt.
   */
  function bilderFor(f, s) {
    var ut = [];
    var seenExact = {};
    var seenNear = {};
    function push(src, t, zoom) {
      if (!src) return;
      var key = imageKey(src);
      var near = imageNearKey(src);
      if (!key || seenExact[key]) return;
      if (near && seenNear[near]) return;
      seenExact[key] = true;
      if (near) seenNear[near] = true;
      ut.push({ src: src, t: t, zoom: !!zoom });
    }
    var st = currentProduct(f, s);
    if (st && st.bild) push(st.bild, 'Produktbild ' + sizeLabel(s) + ' cm');
    if (f.nara) push(f.nara, 'Tyget på nära håll');
    ((st && st.miljo) || []).forEach(function (m) {
      push(m, 'Inspiration');
    });
    return ut;
  }

  var PK_HASH_SIZE = 8;
  var PK_HASH_MAX_DIST = 6; /* av 64 bitar — fångar nara≈miljö-reencodes */

  function absoluteMediaUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return (location.protocol || 'https:') + src;
    return src;
  }

  function aHashFromBitmap(bmp) {
    var c = document.createElement('canvas');
    c.width = PK_HASH_SIZE;
    c.height = PK_HASH_SIZE;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    if (!ctx) return '';
    ctx.drawImage(bmp, 0, 0, PK_HASH_SIZE, PK_HASH_SIZE);
    var data = ctx.getImageData(0, 0, PK_HASH_SIZE, PK_HASH_SIZE).data;
    var grays = [];
    var sum = 0;
    var i;
    for (i = 0; i < data.length; i += 4) {
      var g = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
      grays.push(g);
      sum += g;
    }
    var avg = sum / grays.length;
    var out = '';
    for (i = 0; i < grays.length; i++) out += grays[i] >= avg ? '1' : '0';
    return out;
  }

  function hammingDist(a, b) {
    if (!a || !b || a.length !== b.length) return 999;
    var d = 0;
    var i;
    for (i = 0; i < a.length; i++) if (a.charAt(i) !== b.charAt(i)) d++;
    return d;
  }

  function loadBitmap(src) {
    return fetch(absoluteMediaUrl(src), { credentials: 'same-origin', mode: 'cors' })
      .then(function (r) {
        if (!r.ok) throw new Error('img ' + r.status);
        return r.blob();
      })
      .then(function (blob) {
        return createImageBitmap(blob);
      });
  }

  /* Hoppa över bilder som ser likadana ut (nara-asset = miljöfil). */
  function dedupePerceptual(candidates) {
    if (!candidates || !candidates.length) return Promise.resolve([]);
    if (typeof createImageBitmap !== 'function') return Promise.resolve(candidates);
    return Promise.all(
      candidates.map(function (c) {
        return loadBitmap(c.src)
          .then(function (bmp) {
            var h = aHashFromBitmap(bmp);
            if (bmp && bmp.close) {
              try {
                bmp.close();
              } catch (e) {}
            }
            return { c: c, h: h };
          })
          .catch(function () {
            return { c: c, h: '' };
          });
      })
    ).then(function (rows) {
      var kept = [];
      var hashes = [];
      rows.forEach(function (row) {
        if (row.h) {
          var dup = hashes.some(function (kh) {
            return hammingDist(kh, row.h) <= PK_HASH_MAX_DIST;
          });
          if (dup) return;
          hashes.push(row.h);
        }
        kept.push(row.c);
      });
      return kept;
    });
  }

  function oppnaPanel(tk, j) {
    panel.scrollTop = 0;
    var f = TYGER[tk].farger[j];
    var kap = document.getElementById('pk-' + tk);
    var kst = (kap && kap.dataset.pkStorlek) || '50x50';
    if (!f.storlekar[kst]) kst = f.storlekar['50x50'] ? '50x50' : '40x60';
    pv = { tyg: tk, farg: f, storlek: kst, inner: true, i: 0 };
    ritaPanel();
    panel.classList.add('is-oppen');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function stangPanel() {
    var x = panel.querySelector('.pk-lib__stang svg');
    if (x) {
      x.style.transform = 'rotate(90deg)';
      setTimeout(function () {
        x.style.transform = '';
      }, 500);
    }
    panel.classList.remove('is-oppen');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var pop = $('[data-pk-storepop]', root);
    if (pop) {
      pop.classList.remove('is-open');
      pop.hidden = true;
    }
  }

  function syncGalleryChrome() {
    if (!pv || !pv.bilder || !pv.bilder.length) return;
    var lin = $('[data-pk-linje]', root);
    if (!lin) return;
    lin.style.setProperty('--w', 100 / pv.bilder.length + '%');
    lin.style.setProperty('--x', pv.i);
  }

  function buildGalleryTrack() {
    var track = $('[data-pk-track]', root);
    if (!track || !pv || !pv.bilder) return;
    track.innerHTML = pv.bilder
      .map(function (o) {
        return (
          '<div class="pk-lib__slide' +
          (o.zoom ? ' is-zoomad' : '') +
          '"><img alt="" src="' +
          o.src +
          '" width="1200" height="1600" draggable="false"></div>'
        );
      })
      .join('');
  }

  /* Sidleds glide (inte opacity-fade). animate:false vid öppning/storleksbyte/wrap. */
  function ritaBild(opts) {
    if (!pv || !pv.bilder || !pv.bilder.length) return;
    var track = $('[data-pk-track]', root);
    if (!track) return;
    var animate = !opts || opts.animate !== false;
    if (!animate) track.classList.add('is-instant');
    track.style.transform = 'translateX(' + -pv.i * 100 + '%)';
    if (!animate) {
      void track.offsetWidth;
      track.classList.remove('is-instant');
    }
    syncGalleryChrome();
  }

  function goGallery(delta) {
    if (!pv || !pv.bilder || !pv.bilder.length) return;
    var n = pv.bilder.length;
    var from = pv.i;
    var next = (from + delta + n) % n;
    /* Wrap (sista→första) hoppar utan lång reverse-glide. */
    var wraps = Math.abs(next - from) > 1;
    pv.i = next;
    ritaBild({ animate: !wraps });
  }

  function innerVariantId(s) {
    return s === '40x60' ? INNER.v40 : INNER.v50;
  }
  function innerAvailable(s) {
    return s === '40x60' ? INNER.avail40 : INNER.avail50;
  }

  function ritaPanel() {
    var t = TYGER[pv.tyg];
    var f = pv.farg;
    var st = currentProduct(f, pv.storlek);
    var candidates = bilderFor(f, pv.storlek);
    var galGen = (pv.galGen = (pv.galGen || 0) + 1);
    /* Visa URL-unika direkt; byt till perceptuellt unika när hash är klar. */
    pv.bilder = candidates;
    pv.i = Math.min(pv.i, Math.max(0, pv.bilder.length - 1));
    buildGalleryTrack();
    ritaBild({ animate: false });
    dedupePerceptual(candidates).then(function (unique) {
      if (!pv || pv.galGen !== galGen) return;
      if (!unique.length) return;
      pv.bilder = unique;
      pv.i = Math.min(pv.i, unique.length - 1);
      buildGalleryTrack();
      ritaBild({ animate: false });
    });
    $('[data-pk-ptyg]', root).textContent = 'Prydnadskudde · ' + t.namn;
    $('[data-pk-pnamn]', root).textContent = t.namn + ' ' + f.namn;

    $('[data-pk-pst]', root).innerHTML = ['50x50', '40x60']
      .map(function (sz) {
        var q = f.storlekar[sz];
        if (!q) return '';
        return (
          '<button type="button" class="pk-lib__storlek" data-pk-pstorlek="' +
          sz +
          '" aria-pressed="' +
          (sz === pv.storlek) +
          '"><span class="pk-lib__rad"><em></em><span class="pk-lib__sz">' +
          sizeLabel(sz) +
          ' cm</span><span class="pk-lib__pr">' +
          kr(q.price) +
          '</span></span></button>'
        );
      })
      .join('');

    /* Förvald: pv.inner startar true. Saknas lager → visa status, behåll valet
       så det gäller igen när matchande storlek finns. */
    var canInner = !!innerVariantId(pv.storlek) && innerAvailable(pv.storlek);
    var takeInner = !!pv.inner && canInner;
    $('[data-pk-inner-namn]', root).textContent =
      'Innerkudde ' +
      sizeLabel(pv.storlek) +
      ' cm · ' +
      kr(INNER.price) +
      (canInner ? '' : ' · Tillfälligt slut');
    var innerBtn = $('button[data-pk-inner]', root);
    if (innerBtn) {
      innerBtn.setAttribute('aria-pressed', pv.inner ? 'true' : 'false');
      innerBtn.style.opacity = canInner ? '' : '0.45';
      innerBtn.disabled = !canInner;
    }

    var rows =
      '<div><span>Prydnadskudde ' +
      sizeLabel(pv.storlek) +
      ' ' +
      t.namn +
      ' ' +
      f.namn +
      '</span><span>' +
      kr(st.price) +
      '</span></div>';
    if (takeInner) {
      rows +=
        '<div><span>Innerkudde ' +
        sizeLabel(pv.storlek) +
        ' cm</span><span>' +
        kr(INNER.price) +
        '</span></div>';
    }
    rows +=
      '<div class="pk-lib__tot"><span>Totalt</span><b>' +
      kr(st.price + (takeInner ? INNER.price : 0)) +
      '</b></div>';
    $('[data-pk-rader]', root).innerHTML = rows;

    var kb = $('[data-pk-kop]', root);
    if (window.TamburAtcFeedback) window.TamburAtcFeedback.reset(kb);
    if (!st.available) {
      kb.disabled = true;
      if (window.TamburAtcFeedback) window.TamburAtcFeedback.setLabel(kb, 'Tillfälligt slut');
      else {
        var oosLabel = kb.querySelector('[data-atc-label]');
        if (oosLabel) oosLabel.textContent = 'Tillfälligt slut';
        else kb.textContent = 'Tillfälligt slut';
      }
    } else {
      kb.disabled = false;
      if (window.TamburAtcFeedback) window.TamburAtcFeedback.setLabel(kb, 'Lägg i varukorgen');
      else {
        var atcLabel = kb.querySelector('[data-atc-label]');
        if (atcLabel) atcLabel.textContent = 'Lägg i varukorgen';
        else kb.textContent = 'Lägg i varukorgen';
      }
    }

    var onlineEl = $('[data-pk-lager-online]', root);
    var onlineText = $('[data-pk-lager-online-text]', root);
    if (st.online) {
      onlineEl.classList.remove('is-oos');
      onlineText.innerHTML = '<i class="pk-lib__dot" aria-hidden="true"></i>I lager · skickas inom 1–4 arbetsdagar';
    } else {
      onlineEl.classList.add('is-oos');
      onlineText.innerHTML = '<i class="pk-lib__dot" aria-hidden="true"></i>Tillfälligt slut';
    }
    var butikText = $('[data-pk-lager-butik-text]', root);
    var butikRow = $('[data-pk-butik]', root);
    if (st.inStore) {
      butikRow.classList.remove('is-oos');
      butikText.innerHTML = '<i class="pk-lib__dot" aria-hidden="true"></i>Finns i butik · <u>Stockholm</u>';
    } else {
      butikRow.classList.add('is-oos');
      butikText.innerHTML = '<i class="pk-lib__dot" aria-hidden="true"></i>Inte tillgänglig i butik · Stockholm';
    }

    $('[data-pk-ptext]', root).textContent = st.description || t.produkttext || '';
  }

  /* Undvik panel-öppning efter horisontell swipe på kortbilder. */
  var cardSwipe = { moved: false, x: 0, y: 0 };
  root.addEventListener(
    'pointerdown',
    function (e) {
      if (!e.target.closest('[data-pk-card-slider]')) return;
      cardSwipe.moved = false;
      cardSwipe.x = e.clientX;
      cardSwipe.y = e.clientY;
    },
    true
  );
  root.addEventListener(
    'pointermove',
    function (e) {
      if (Math.abs(e.clientX - cardSwipe.x) > 10 || Math.abs(e.clientY - cardSwipe.y) > 10) {
        cardSwipe.moved = true;
      }
    },
    true
  );

  root.addEventListener('click', function (e) {
    var k = e.target.closest('[data-pk-kort]');
    if (k && root.contains(k)) {
      if (cardSwipe.moved) {
        cardSwipe.moved = false;
        e.preventDefault();
        return;
      }
      e.preventDefault();
      oppnaPanel(k.closest('.pk-lib__kap').dataset.pkTyg, +k.dataset.pkKort);
      return;
    }

    if (!panel.classList.contains('is-oppen')) return;

    if (e.target.closest('[data-pk-stang]')) {
      stangPanel();
      return;
    }
    var g = e.target.closest('[data-pk-g]');
    if (g) {
      goGallery(+g.dataset.pkG);
      return;
    }
    var ps = e.target.closest('[data-pk-pstorlek]');
    if (ps) {
      pv.storlek = ps.dataset.pkPstorlek;
      pv.i = 0;
      ritaPanel();
      return;
    }
    if (e.target.closest('button[data-pk-inner]')) {
      if (innerAvailable(pv.storlek) && innerVariantId(pv.storlek)) {
        pv.inner = !pv.inner;
        ritaPanel();
      }
      return;
    }
    if (e.target.closest('[data-pk-kop]')) {
      var stP = currentProduct(pv.farg, pv.storlek);
      if (!stP || !stP.available) return;
      var items = [{ id: stP.variantId, quantity: 1 }];
      if (pv.inner && innerVariantId(pv.storlek) && innerAvailable(pv.storlek)) {
        items.push({ id: innerVariantId(pv.storlek), quantity: 1 });
      }
      var tookInner = items.length > 1;
      var kb = $('[data-pk-kop]', root);
      kb.disabled = true;
      if (window.TamburAtcFeedback) window.TamburAtcFeedback.press(kb);
      addItems(items)
        .then(function (data) {
          (data && Array.isArray(data.items) ? data.items : [data]).forEach(function (item) {
            document.dispatchEvent(new CustomEvent('tambur:tracking:add-to-cart', { detail: item }));
          });
          if (window.TamburAtcFeedback) {
            window.TamburAtcFeedback.success(kb, {
              announce: tookInner
                ? 'Kudde + innerkudde tillagd i korg'
                : kb.getAttribute('data-atc-added-label') || 'Tillagd i korg'
            });
          }
          return syncCartBadges().then(function () {
            var delay =
              window.TamburAtcFeedback && window.TamburAtcFeedback.drawerDelayMs
                ? window.TamburAtcFeedback.drawerDelayMs()
                : 0;
            if (delay > 0) {
              setTimeout(openCartDrawer, delay);
            } else {
              openCartDrawer();
            }
          });
        })
        .catch(function (err) {
          if (window.TamburAtcFeedback) window.TamburAtcFeedback.fail(kb);
          alert((err && err.description) || 'Kunde inte lägga i varukorgen.');
        })
        .finally(function () {
          kb.disabled = false;
        });
      return;
    }

    var butik = e.target.closest('[data-pk-butik]');
    var storeClose = e.target.closest('[data-pk-storeclose]');
    var pop = $('[data-pk-storepop]', root);
    if (storeClose) {
      var sv = storeClose.querySelector('svg');
      if (sv) {
        sv.style.transform = 'rotate(90deg)';
        setTimeout(function () {
          sv.style.transform = '';
          pop.classList.remove('is-open');
          pop.hidden = true;
        }, 380);
      } else {
        pop.classList.remove('is-open');
        pop.hidden = true;
      }
      return;
    }
    if (butik) {
      var nm = $('[data-pk-pnamn]', root);
      $('[data-pk-storetext]', root).textContent =
        (nm && nm.textContent ? nm.textContent : 'Varan') + ' finns i butiken';
      var d = new Date();
      var day = d.getDay();
      var h = d.getHours() + d.getMinutes() / 60;
      var closes = day >= 1 && day <= 5 ? 18 : day === 6 ? 17 : 0;
      $('[data-pk-opennow]', root).textContent =
        closes && h >= 11 && h < closes ? 'Öppet nu · stänger ' + closes + '.00' : 'Stängt just nu · öppnar 11.00';
      pop.hidden = false;
      pop.classList.toggle('is-open');
    }
  });

  addEventListener('keydown', function (e) {
    if (!panel.classList.contains('is-oppen')) return;
    if (e.key === 'Escape') stangPanel();
    if (e.key === 'ArrowRight') goGallery(1);
    if (e.key === 'ArrowLeft') goGallery(-1);
  });

  var tx = null;
  var gal = $('[data-pk-galleri]', root);
  gal.addEventListener(
    'touchstart',
    function (e) {
      tx = e.touches[0].clientX;
    },
    { passive: true }
  );
  gal.addEventListener('touchend', function (e) {
    if (tx === null || !pv) return;
    var dx = e.changedTouches[0].clientX - tx;
    tx = null;
    if (Math.abs(dx) > 40) goGallery(dx < 0 ? 1 : -1);
  });

  /* Mobil: svepband + FLIP */
  $$('[data-pk-svep]', root).forEach(function (sv) {
    var kap = sv.closest('.pk-lib__kap');
    var lin = kap.querySelector('.pk-lib__svep-linje');
    var sist = 0;
    var t;
    sv.addEventListener(
      'scroll',
      function () {
        var j = Math.round(sv.scrollLeft / Math.max(1, sv.clientWidth));
        if (lin) lin.style.setProperty('--x', j);
        if (j === sist) return;
        sist = j;
        clearTimeout(t);
        t = setTimeout(function () {
          var kort = $$('[data-pk-kort]', kap);
          var fore = kort.map(function (a) {
            return a.getBoundingClientRect();
          });
          kort.forEach(function (a) {
            a.style.order = +a.dataset.pkKort === j ? -1 : 0;
            a.classList.toggle('is-vald', +a.dataset.pkKort === j);
          });
          kort.forEach(function (a, n) {
            var r = a.getBoundingClientRect();
            var dx = fore[n].left - r.left;
            var dy = fore[n].top - r.top;
            if (!dx && !dy) return;
            a.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], {
              duration: 550,
              easing: 'cubic-bezier(.2,.7,.2,1)'
            });
          });
        }, 180);
      },
      { passive: true }
    );
    sv.addEventListener('click', function (e) {
      var f = e.target.closest('[data-pk-svepi]');
      if (!f) return;
      var k = kap.querySelector('[data-pk-kort="' + f.dataset.pkSvepi + '"]');
      if (k) k.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
  } /* boot */
})();
